import React, { Component } from 'react'
import { Form, Input, Upload, Icon, Modal, Select, Cascader, InputNumber, Button, Radio, Drawer, Steps, message } from 'antd'
import { api, app, config } from '../../app'
import "./ssss.css";

const FormItem = Form.Item
const RadioGroup = Radio.Group
const { Option, OptGroup } = Select

function formItemLayout(num = 12) {
    return {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: num },
        }
    }
}

class MMAddGood extends Component {
    constructor(props) {
        super(props)
        this.state = {
            previewImage: '',
            previewImage2: '',
            fileList: [], // 商品图片
            fileList2: [], // 商品描述图片
            previewVisible: false,
            previewVisible2: false,
            submit_loading: false,
            images: [],
            classList: [], // 商品分类数据

            edit_modal: false, // 规格编辑修改弹窗
            spec_data: [], // 规格属性
            dataSource: {}, // 数据源
            isEdit: false, // 是否添加（编辑）商品 false 添加 true 编辑

            type: "1",
            t_loading: false, // 表格loading
            total: 0, // 总数
            page: 1, // 当前选中的页码
            page_length: 20, // 每页的数据数量
            sel_id: "", // 不通过时的选中id
            sel_detail: {}, // 选中的详情
            merchant_logo: [], //店铺logo
            business_license: [], //营业执照 厂商才显示
            product_img: [], //商品原图
            quality_img: [], //质量证明原图
            manufacturer_img: [], //描述图片原图
            review_url: "", //商品首图url
            product_name: "", //搜索的商品名
            isData: false, //数据是否赋值
            delStatus: true,

            merchant_iname: "-1", //商家筛选选中的id -1表示全部
            audit_iname: "1", //审核筛选选中的id 1表示已通过
            MerchantData: [], // 商家店铺数据
            auditData: [
                {
                    value: "全部",
                    status: "-1"
                },
                {
                    value: "待审核",
                    status: "0"
                },
                {
                    value: "已通过", // 默认状态
                    status: "1"
                },
                {
                    value: "不通过",
                    status: "2"
                }
            ], // 审核数据

            formInline: {
                id: "",
                goodsImg: "",
                goodsTitle: "",
                type: "",
                freeShippingValue: "",
                price: "",
                unit: "",
                specifications: "",
                shipment: "",
                province: "",
                city: "",
                goods_desc: "",
                goodsImg_desc: "",
                hint_info: "",
                // goodsQualityImg: "",
                putonStatus: "",
                first_weight_number: 0
            },

            goods_file_list: [], // 商品列表
            goods_file_list_desc: [], // 商品描述图片列表
            goods_quality_list: [], // 商品质量证明

            spec_input_title: "", // 设置规格属性弹框中的规格名称输入框的值
            spec_data: [], // 规格属性
            data2: [], // 属性数据
            data3: [], // 被删除的属性数据
            isExistSpec: false, // 是否存在该规格属性
            // 判定被删除的规格数据是已存在的
            isReg: true, // treu: 存在 false:不存在
            variety_list: "", // 商品种类
            itemSpeName: "", // 规格名暂存值
            lindex: 0,
            voidsName: "", // 选中输入的分类值名字
            descValue: "", // 分类描述
            itemPrice: "", // 单价暂存值
            itemStock: "", // 库存暂存值
            classImgList: [], // 分类图片

            goodsStatus: 1,
            goodsType: 10,
            unit_list: "", // 单位
            logiData: [], // 物流方式
            editSpecDesc: false, // 修改属性单价、库存和图片
            renameSpec: false, // 规格重命名
            spec_edit_status: false,
            current: 0, // 设置规格步骤

            detail_modal: false, // 详情框
            winStatus: false, // 橱窗选择框
            edit_modal: false, // 编辑修改框
            pc_modal: false, // 选择发货地弹框
            spec_modal: false, // 规格弹框
            current_pc: "", // 当前选择的是省还是市
            current_province: "", // 当前选择的省
            current_city: "", // 当前选择的市
            province_value: "",
            city_value: "",
            province_list: [], // 省份列表
            city_list: [], // 城市列表
            ruleNum: 0, // 表单通过规则数
            ruleTotalNum: 11, // 表单通过规则总数

            winInfo: {}, // 选中的橱窗数据
            win_list: [] // 橱窗数据
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.getClassList();
        if (this.props.info.product_id != '' && this.props.info.product_id != undefined) {
            // 加载商品详情
            console.log("加载商品详情");
            this.setState({ isEdit: true })
            this.getData();
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    // 初始化form表单
    // initForm = () => {
    //     const { form, info } = this.props;
    //     if (info.id != '') {
    //         this.getData();
    //         // let a = [];
    //         // info.product_img.forEach(e => {
    //         //     a.push(e);
    //         // });
    //         // this.fileList = a;
    //         console.log(info.product_img);
    //         console.log(typeof (info.product_img));
    //     }
    // }

    // 获取分类集合
    getClassList = () => {
        const _this = this, params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type: 1,
        }
        app.post(api.MallClassListing, params).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    const classList = data.map((cla) => {
                        return {
                            label: cla.class_name,
                            value: cla.id,
                            // 2022-06-23 cwj 暂时没有二级分类
                            // children: (cla.subclass || []).map((sub) => {
                            //     return {
                            //         label: sub.class_name,
                            //         value: sub.id,
                            //         children: (sub.subclass || []).map((sub1) => {
                            //             return {
                            //                 label: sub1.class_name,
                            //                 value: sub1.id
                            //             }
                            //         })
                            //     }
                            // })
                        }
                    })
                    _this.setState({ classList })
                } else {
                    app.alert(msg, 'warn')
                }
            }
        })
    }

    // 获取商品详情
    getData = () => {
        const _this = this, params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            mall_id: _this.props.info.id,
        }
        app.post(api.AdminMallDetail, params).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    console.log(data);
                    // 处理分类id
                    let a = [];
                    a.push(data.mall_class);
                    // 处理商品图片
                    let b = [];
                    if (data.product_img.length > 0) {
                        data.product_img.forEach((e, i) => {
                            if (e != '') {
                                b.push({
                                    url: config.imgUrl + e,
                                    uid: i
                                });
                            }
                        })
                    }
                    // 处理商品描述图片
                    let c = [];
                    if (data.manufacturer_img.length > 0) {
                        data.manufacturer_img.forEach((e, i) => {
                            if (e != '') {
                                c.push({
                                    url: config.imgUrl + e,
                                    uid: i
                                });
                            }
                        })
                    }
                    console.log('商品分类');
                    console.log(a);
                    console.log('商品图片');
                    console.log(b);
                    console.log('商品描述图片');
                    console.log(c);
                    _this.setState({ dataSource: data, formInline: data, fileList: b || [], fileList2: c || [], })

                    this.props.form.setFieldsValue({
                        class_id: a || [],
                        name: data.ppename || '',
                        images: data.product_img || [],
                        remark: data.remark || '',
                        manufacturer_img: data.manufacturer_img || [],
                        statement: data.statement || '',
                        price: data.ppeprice || '',
                        weight: data.weight || '',
                        produce_number: data.produce_number || '',
                        is_audit: data.is_audit || '',
                        is_astrict: data.is_astrict || '',
                        astrict_how: data.astrict_how || '',
                        astrict_number: data.astrict_number || '',
                        is_team: data.is_team || '',
                        status: data.ifuse || '',
                    })
                } else {
                    app.alert(msg, 'warn')
                }
            }
        })
    }

    // 限制图片后缀
    checkImgSuffix = (e) => {
        // 'jpg', 'gif', 'png', 'jpeg'
        if (e == 'image/jpg' || e == 'image/gif' || e == 'image/png' || e == 'image/jpeg') {
            return true;
        } else {
            return false
        }
    }

    // 商品图片展示
    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        })
    }

    // 商品图片图片展示
    handlePreview2 = (file) => {
        this.setState({
            previewImage2: file.url || file.thumbUrl,
            previewVisible2: true,
        })
    }

    handleChange = ({ file, fileList }) => {
        this.setState({ fileList }, () => {
            if (!this.checkImgSuffix(file.type)) {
                this.setState({ fileList: [] })
            } else if (file.status === 'done') {
                if (file.response.flag === 1) {
                    this.setState({ fileList })
                    // console.log('上传成功')
                } else {
                    app.alert(file.response.msg, 'warn')
                    this.setState({ fileList: [] })
                }
            }
        })
    }

    handleChange2 = ({ file, fileList }) => {
        console.log(0);
        this.setState({ fileList2: fileList }, () => {
            console.log('000');
            if (!this.checkImgSuffix(file.type)) {
                console.log(1);
                this.setState({ fileList2: [] })
            } else if (file.status === 'done') {
                console.log(2);
                if (file.response.flag === 1) {
                    console.log(file)
                    this.setState({ fileList2: fileList })
                    setTimeout(() => {
                        console.log(this.state.fileList2)
                    }, 500);
                } else {
                    console.log(3);
                    app.alert(file.response.msg, 'warn')
                    this.setState({ fileList2: [] })
                }
                console.log(3);
            }
            console.log(4);
        })
        console.log(5);
    }

    handleCancel = () => this.setState({ previewVisible: false })
    handleCancel2 = () => this.setState({ previewVisible2: false })

    // 提交
    handleSubmit = (e) => {
        e.preventDefault()
        const { info } = this.props;
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                // if (values.spec == '' || values.spec == undefined) {
                //     app.alert("请新增规格", "warn")
                //     return false
                // }
                const _this = this, params = {
                    indexno: app.getData('indexno'),
                    account: app.getData('account'),
                }
                values.class_id = values.class_id[values.class_id.length - 1]
                values.images = this.state.fileList.join(":::");
                // values.manufacturer_img = values.images.file.response.data.url
                // values.manufacturer_img = values.manufacturer_img.file.response.data.url
                values.manufacturer_img = this.state.fileList2.join(":::");
                values = Object.assign(params, values)
                let a1 = [{ "name": "净含量", "flag": 1, "list": [{ "name": "800", "flag": "1" }] }];
                let a2 = [{ "price": "98.00", "sku_img": "", "stock": "2685", "spec_value": ["800"] }];
                values.spec_list_json = JSON.stringify(a1);
                values.spec_info_json = JSON.stringify(a2);
                console.log(this.state.fileList);
                console.log(this.state.fileList2);
                console.log(values);
                console.log(info);

                if (values.images == '' || values.images == undefined) {
                    app.alert("请上传商品图片", "warn")
                    return false
                }

                if (values.manufacturer_img == '' || values.manufacturer_img == undefined) {
                    app.alert("请上传商品描述图片", "warn")
                    return false
                }

                app.post(api.AdminMallAdd, values).then(({ flag, data, msg }) => {
                    if (_this._isMounted) {
                        if (flag === 1) {
                            let a = '';
                            if (info.id == '') {
                                a = '添加成功';
                            } else {
                                a = '修改成功';
                            }
                            app.alert(a, 'success')
                            _this.props.form.resetFields()
                            _this.setState({ fileList: [], fileList2: [] })
                        } else {
                            app.alert(msg, 'warn')
                        }
                    }
                })
            }
        })
    }

    // 商品图片上传前
    handleBeforeUpload = (file) => {
        if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/gif' || file.type === 'image/png') {
            return true
        }
        app.alert('请上传jpg,jpeg,png,gif格式的图片', 'warn')
        this.setState({ fileList: [] })
        return false
    }

    // 商品描述图片上传前
    handleBeforeUpload2 = (file) => {
        if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/gif' || file.type === 'image/png') {
            return true
        }
        app.alert('请上传jpg,jpeg,png,gif格式的图片', 'warn')
        this.setState({ fileList2: [] })
        return false
    }

    // 打开新增（修改）规格弹窗
    openSpecBox123 = () => {

        // const {edit_modal} = this.state;

        // // 关闭弹窗
        // if (edit_modal) {
        //     await this.setData({
        //         edit_modal: false,
        //         spec_data: [],
        //         data2: [],
        //     });
        // } else {
        //     // 打开弹窗
        //     // 判断是新增还是
        //     await this.setData({
        //         edit_modal: true,
        //         spec_data: [],
        //         data2: [],
        //     });
        // }
    }

    // 打开规格弹框
    openSpecBox = async () => {
        this.setState({
            spec_modal: true
        })
        const { formInline, winInfo } = this.state;
        // 获取规格详情
        if (formInline.id != "") {
            app.alert("加载规格详情")
            // await getLogistics({
            //     product_id: formInline.id,
            //     merchant_id: winInfo.merchant_id,
            // });
        }
    }

    // 关闭设置规格弹框
    closeTheDrawer() {
        message.info("关闭设置规格弹框2333");
        this.setState({
            isExistSpec: false,
            spec_edit_status: false,
            spec_input_title: "",
        })
    }

    // 关闭重命名规格弹框
    closeTheRenameDrawer() {
        this.setState({
            renameSpec: false,
            itemSpeName: "",
        })
    }

    // 关闭修改规格单价详情弹框
    closeTheEditDrawer() {
        this.setState({
            editSpecDesc: false,
            itemSpeName: "",
            classImgList: [],
        })
    }

    // 点击保存设置的规格名称值
    save_spec_title() {
        let a = this.state.spec_data;
        let e = this.state.spec_input_title;
        let isTrue = true;
        console.log(a);
        if (a != '') {
            a.forEach(i => {
                if (e == i.title) {
                    this.setState({
                        isExistSpec: true,
                    })
                    isTrue = false;
                    message.error("规格名称：" + e + "已存在");
                }
            });
        }

        if (e == "") {
            isTrue = false;
            message.warning("请输入规格名称");
        }

        if (isTrue) {
            let b = {
                name: "",
                flag: 1
            };
            let c = {
                title: e,
                flag: 1,
                datai: []
            };
            let d = this.state.spec_data;
            c.datai.push(b);
            d.push(c);
            this.setState({
                isExistSpec: false,
                spec_edit_status: false,
                spec_input_title: "",
                spec_data: d,
            })
        }
    }

    save_spec_title2(e) {
        // console.log(e.currentTarget.value)
        this.setState({
            spec_input_title: e.currentTarget.value
        })
    }

    // 点击保存重命名的规格名称值
    save_spec_rename_title(e) {
        const { spec_data, lindex } = this.state;
        let a = true;
        let b = spec_data;
        if (e !== "") {
            b.forEach(i => {
                if (e == i.title) {
                    message.warning("该规格名已存在");
                    a = false;
                }
            });
        }
        if (a) {
            b.forEach((i, j) => {
                if (j == lindex) {
                    i.title = e;
                }
            });
            this.setState({
                renameSpec: false,
                itemSpeName: '',
                spec_data: b,
            })
        }
    }

    // 上传（编辑）商品（调接口）
    async uploadproduct(a, b) {
        // console.log({ a, b });
        let res = {};
        const { winInfo } = this.state;
        const _this = this;
        if (b == "") {
            // 新增商品
            // 判断是否有橱窗id：新增产品需要传这个参，编辑产品则不用
            if (winInfo.id == "" || winInfo.id == undefined) {
                return false;
            } else {
                // a.product_window_id = winInfo.id;
                // res = await setGoodsDetail(a);
                const params = {
                    // indexno: app.getData('indexno'),
                    // account: app.getData('account'),
                    product_window_id: winInfo.id,
                }
                app.post(api.setGoodsDetail, params).then(data => {
                    res = data;
                })
            }
        } else {
            // a.product_id = b;
            const params = {
                product_id: b,
            }
            app.post(api.setGoodsDetail, params).then(data => {
                res = data;
            })
        }

        if (res.flag === 1) {
            message.success(res.msg);
            // 重置表单
            this.handleCloseEditModal("formInline");
            // 刷新页面
            this.handleFilterChange();
        } else {
            message.error(res.msg);
        }
    }

    /**
     * 清除省份或者市区
     */
    async clear_pc(e) {
        e.stopPropagation();
        // event.cancelBubble = true
        if (e == "p") {
            this.setState({
                current_province: "",
                current_city: "",
                city_list: [],
            })
        } else {
            this.setState({
                current_city: "",
            })
        }
    }

    // 当有id时则调接口保存，否则不调接口
    saveLogistics = async () => {
        const { formInline, spec_data, data3, winInfo, data2 } = this.state;
        // 存在id时
        if (formInline.id != "") {
            let newid = []; // 名称属性暂存值
            if (spec_data != "") {
                let oid = spec_data;
                oid.forEach(e => {
                    let obj = {
                        // spec_id: e.spec_id || '',
                        name: e.title,
                        // flag: e.flag,
                        is_delete: e.is_delete == undefined ? 0 : e.is_delete,
                        list: []
                    };

                    if (e.spec_id) {
                        obj.spec_id = e.spec_id;
                    }

                    if (e.datai) {
                        // obj.is_delete = 0;
                        let newid2 = [];
                        e.datai.forEach(j => {
                            let obj2 = {
                                name: j.name,
                                flag: j.flag,
                                value_id: j.value_id,
                                is_delete: j.is_delete
                            };
                            // if (j.flag == 0) {

                            // }
                            newid2.push(obj2);
                        });
                        obj.list = newid2;
                    }
                    newid.push(obj);
                });
                // console.log(newid);
                // console.log(this.data3);
                let odeldata = data3;
                // 当已删除数据a中存在已有规格数据b属性时，把对应b的值a放到b里面去,并且把对应的数据从a中删除
                newid.forEach(i => {
                    odeldata.forEach((e, p) => {
                        if (i.spec_id == e.spec_id) {
                            let k = {};
                            e.list.forEach(j => {
                                k = {
                                    flag: j.flag,
                                    is_delete: 1,
                                    name: j.name,
                                    value_id: j.value_id
                                };
                            });
                            i.list.push(k);
                            odeldata.splice(p, 1);
                        }
                    });
                });
                // console.log(odeldata);
                // console.log(newid);
                // 再次循环，检查已删除数据a中是否存在不存在已有规格数据b的数据，如果存在，则将对应的数据把a和b合并
                newid.forEach(i => {
                    odeldata.forEach((e, p) => {
                        if (i.spec_id != e.spec_id) {
                            newid.push(e);
                            odeldata.splice(p, 1);
                        }
                    });
                });
                // console.log(odeldata);
                // 再次循环，检查已删除数据中的数据a存在已存在数据b中且b全等于a时，即b中数据已全部被删除时，则设b的is_delete为1
                // let isDew = true;
                let isDewNum = 0;

                newid.forEach(i => {
                    i.list.forEach((j, v, arr) => {
                        if (j.is_delete == 1) {
                            console.log(arr);
                            // console.log(j);
                            // isDew = false;
                            isDewNum++;
                        }
                    });
                    if (i.list.length == isDewNum) {
                        i.is_delete = 1;
                    }
                });
                newid = newid.concat(data3);
            }

            // 再次循环，如果是删除已存在的规格c，再新建相同名字的规格c，然后再删除规格c，这种情况就不把新的规格c放到newid中
            // let isDew = true;
            newid.forEach((i, j) => {
                if (i.is_delete == 1 && i.spec_id == undefined) {
                    newid.splice(j, 1);
                    // console.log(i.spec_id);
                }
            });

            // 再次循环。。进行排序：已删除的放在前面
            newid.sort(function (a, b) {
                if (a.is_delete > b.is_delete) {
                    return -1;
                } else if (a.is_delete == b.is_delete) {
                    return 0;
                } else {
                    return 1;
                }
            });
            let a = '';
            let b = {
                merchant_id: winInfo.merchant_id,
                product_id: formInline.id,
                spec_list_json: newid == "" ? "" : JSON.stringify(newid), // 规格属性列表（name:规格名称 list:属性数组）
                spec_info_json: data2 == "" ? "" : JSON.stringify(data2) // 规格属性信息（sku_img:属性图片 price:单价 stock:库存数量 spec_value:属性数组）
            };
            app.post(api.setLogistics, b).then(data => {
                a = data;
            })
            if (a.flag === 1) {
                this.setState({
                    spec_modal: false,
                    spec_edit_status: false,
                    current: 0,
                })
                this.handleCloseEditModal("formInline");
            }
        } else {
            this.setState({
                spec_modal: false,
                spec_edit_status: false,
                current: 0,
            })
        }
    }

    // 获取下标
    getIndex(r, p) {
        this.setState({
            lindex: r,
            voidsName: p,
        })
    }

    // 显示自定义属性
    handleShowAttr(n, s) {
        let a = this.state.spec_data;
        a.forEach(k => {
            if (k.title == s.title) {
                k.datai.forEach((q, p) => {
                    if (p == n) {
                        if (q.flag == 1) {
                            q.flag = 0;
                        } else {
                            q.flag = 1;
                        }
                    }
                });
            }
        });
        this.setState({
            spec_data: a,
        })
    }

    // 下一步
    next() {
        const { spec_data, data2 } = this.state;
        let noRight = false;
        if (spec_data == "") {
            message.warning("请新增规格");
            noRight = true;
        }
        let newData = [];
        if (spec_data != "" || spec_data != []) {
            let a = spec_data;
            a.forEach(i => {
                i.datai.forEach(j => {
                    newData.push(j.name);
                    if (j.name == "") {
                        message.warning("属性名称不能为空");
                        noRight = true;
                    }
                });
            });
            this.setState({
                spec_data: a,
            })
        }

        if (!noRight) {
            let lista = [];
            let list = spec_data;
            for (let s = 0; s < list.length; s++) {
                let sarr = list[s].datai;
                let lists = [];
                for (let v = 0; v < sarr.length; v++) {
                    lists.push(sarr[v].name);
                }
                lista.push(lists);
            }
            let specData = this.cartesianProductOf(...lista);
            let newData = [];
            specData.forEach(i => {
                let obj = {
                    sku_img: "",
                    price: "",
                    stock: "",
                    spec_value: i
                };
                newData.push(obj);
            });
            if (data2.length > 0) {
                let a = data2;
                a.forEach((i, l) => {
                    newData.forEach((j, k) => {
                        if (k == l) {
                            j.sku_id = i.sku_id;
                            j.price = i.price;
                            j.stock = i.stock;
                            j.sku_img = i.sku_img;
                        }
                    });
                });
            }
            this.setState({
                data2: newData,
                current: 1,
            })
        }
    }

    // 上一步
    prev() {
        this.setState({
            current: 0,
        })
    }

    // 保存
    save() {
        let a = true;
        let b = this.state.data2;
        try {
            b.forEach(i => {
                if (i.price === "") {
                    message.warning("单价不能为空");
                    a = false;
                    throw new Error();
                }
                if (i.price === 0) {
                    message.warning("单价不能为0");
                    a = false;
                    throw new Error();
                }
                if (i.stock == "") {
                    i.stock = 0;
                }
            });
            this.setState({
                data2: b,
            })
        } catch (e) {
            console.log(e.message);
        }

        if (a) {
            // spec_list_json2
            // spec_info_json2
            // 调起保存规格接口
            this.saveLogistics();
        }
    }

    // 处理规格数据：逐层嵌套遍历规格名称数组，
    cartesianProductOf() {
        return Array.prototype.reduce.call(
            arguments,
            function (a, b) {
                var ret = [];
                a.forEach(function (a) {
                    b.forEach(function (b) {
                        ret.push(a.concat([b]));
                    });
                });
                return ret;
            },
            [[]]
        );
    }

    // 打开选择省市弹框
    select_pc(e) {
        if (e == "province") {
            this.setState({
                current_pc: "p",
            })
        } else {
            this.setState({
                current_pc: "c",
            })
        }
        if (e == "city" && this.current_province == "") {
            message.warning("请先选择省份");
        } else {
            this.setState({
                pc_modal: true,
            })
        }
    }

    // 上传商品图片
    async handleImgChange(e) {
        let a = [];
        e.forEach(i => {
            a.push(i.url);
        });
        this.setState({
            goods_file_list: e,
            formInline: { ...this.formInline, goodsImg: e }
        })
        // 该图片为空
        // if (!this.checkDeepRules.img1) {
        //   this.checkRule(1);
        // }
    }

    // 上传质量证明
    // async get_goods_quality_list(e) {
    //   let a = [];
    //   e.forEach(i => {
    //     a.push(i.url);
    //   });
    //   this.goods_quality_list = e;
    //   this.formInline = { ...this.formInline, goodsQualityImg: e };
    // },

    // 上传商品描述图片
    async handleImgChange_desc(e) {
        let a = [];
        e.forEach(i => {
            a.push(i.url);
        });
        this.setState({
            goods_file_list_desc: e,
            formInline: { ...this.formInline, goodsImg_desc: e }
        })
    }

    // 上传分类图片
    async handleImgChange_img_box(e) {
        let a = [];
        let b = this.data2;
        e.forEach(i => {
            a.push(i.url);
        });
        // this.classImgList_img = a.join(":::");
        b.forEach((e, i) => {
            if (i == this.lindex) {
                e.sku_img = a.join(":::");
            }
        });
        this.setState({
            classImgList: e,
            data2: b,
        })
    }

    // 选择是否包邮
    getNumber(e) {
        // console.log(e);
        let a = this.state.formInline;
        this.setState({
            formInline: { ...a, first_weight_number: e },
        })
    }

    // 关闭选择橱窗弹框
    handleCloseWin_modal() {
        this.setState({
            winStatus: false,
            win_list: "",
        })
    }

    // 关闭选择省市弹框
    handleClosePc_modal() {
        this.setState({
            pc_modal: false,
        })
    }

    // 省份筛选变更
    async changeProvince(e) {

        let a = this.state.formInline;
        this.setState({
            pc_modal: false,
            current_province: e,
            formInline: { ...a, province: e },
            current_city: '',
            city_list: [],
        })

        if (e) {
            this.setState({
                province_value: false,
                class_list: [],
            })
            await this.getCityList(e);
        }
    }

    // 城市筛选变更
    async changeCity(e) {
        this.setState({
            pc_modal: false,
            current_city: e,
            formInline: e,
        })
    }

    // 获取省份数据
    getProvinceList = async () => {
        let req = '';
        app.post(api.getCity, { type: 1 }).then(data => {
            req = data;
        })
        if (req.flag === 1) {
            const list = req.data || [];
            this.setState({
                province_list: list,
            })
        }
    }

    // 获取城市数据
    async getCityList(e) {
        let req = '';
        app.post(api.getCity, { type: 2, province_name: e }).then(data => {
            req = data;
        })
        if (req.flag === 1) {
            const list = req.data || [];
            this.setState({
                city_list: list,
            })
        }
    }

    // 选择橱窗
    selectWindow(e) {
        this.setState({
            edit_modal: true,
            winStatus: false,
            winInfo: e,
        })
    }

    // 发布商品
    handleSubmit(name, id) {
        const { formInline } = this;
        this.$refs[name].validate(valid => {
            console.log(valid);
            if (valid) {
                let newid = [];
                if (this.spec_data != "") {
                    let oid = this.spec_data;
                    // [{"title":"1212","flag":1,"datai":[{"name":"555","flag":1}]}]
                    // [{"name":"黄金大衣","flag":1,"list":[{"name":"中长款","flag":1}]}]

                    // [{"sku_img":"/Uploads/Product/20220506/6274d2615e78d.png","price":"100","stock":"200","spec_value":["白色"]},
                    //  {"sku_img":"/Uploads/Product/20220506/6274d26f0a9f3.jpg","price":"505","stock":"505","spec_value":["黑色"]}]
                    // [{"sku_img":"/Uploads/Certificate/20220506/6274cfd9aba7f.jpg","price":"6000","stock":"7","spec_value":["中长款"]}]
                    oid.forEach(e => {
                        let obj = {
                            name: e.title,
                            flag: e.flag,
                            list: []
                        };

                        if (e.datai) {
                            let newid2 = [];
                            e.datai.forEach(j => {
                                let obj2 = {
                                    name: j.name,
                                    flag: j.flag
                                };
                                newid2.push(obj2);
                            });
                            obj.list = newid2;
                        }

                        newid.push(obj);
                    });
                }

                // // 处理价格
                // if () {
                //   formInline.price
                // }

                // 处理图片
                let goodsImg2 = [];
                if (formInline.goodsImg != "") {
                    formInline.goodsImg.forEach(e => {
                        if (e.url) {
                            goodsImg2.push(e.url);
                        } else {
                            goodsImg2.push(e);
                        }
                    });
                    goodsImg2 = goodsImg2.join(":::");
                } else {
                    goodsImg2 = "";
                }

                let goodsImg_desc2 = [];
                if (formInline.goodsImg_desc != "") {
                    formInline.goodsImg_desc.forEach(e => {
                        if (e.url) {
                            goodsImg_desc2.push(e.url);
                        } else {
                            goodsImg_desc2.push(e);
                        }
                    });
                    goodsImg_desc2 = goodsImg_desc2.join(":::");
                } else {
                    goodsImg_desc2 = "";
                }

                // let goodsQualityImg2 = [];
                // if (formInline.goodsQualityImg != "") {
                //   formInline.goodsQualityImg.forEach(e => {
                //     if (e.url) {
                //       goodsQualityImg2.push(e.url);
                //     } else {
                //       goodsQualityImg2.push(e);
                //     }
                //   });
                //   goodsQualityImg2 = goodsQualityImg2.join(":::");
                // } else {
                //   goodsQualityImg2 = "";
                // }

                let a = {
                    merchant_id: this.winInfo.merchant_id || "",
                    product_img: goodsImg2,
                    product_name:
                        formInline.goodsTitle == "" ? "" : formInline.goodsTitle,
                    product_price: formInline.price == "" ? 0 : formInline.price,
                    product_unit: formInline.unit == "" ? "" : formInline.unit,
                    first_weight_number:
                        formInline.freeShippingValue == 2
                            ? formInline.first_weight_number == null
                                ? 0
                                : formInline.first_weight_number
                            : 0, // 首重还没有
                    variety_id: formInline.type == "" ? "" : formInline.type, // 商品种类id
                    mail_way:
                        formInline.freeShippingValue == ""
                            ? ""
                            : formInline.freeShippingValue, // 物流方式（1包邮，2不包邮）
                    ship_province: formInline.province == "" ? "" : formInline.province,
                    ship_city: formInline.city == "" ? "" : formInline.city,
                    product_manual:
                        formInline.goods_desc == "" ? "" : formInline.goods_desc, // 商品说明（详细描述）
                    manufacturer_img: goodsImg_desc2, // 描述图片 至少上传一张，多张图片(:::)隔开
                    // quality_img: goodsQualityImg2, // 质量证明图片 至少上传一张，多张图片(:::)隔开
                    status:
                        formInline.putonStatus == 1
                            ? 1
                            : formInline.putonStatus == 2
                                ? 0
                                : "",
                    hint_info: formInline.hint_info == "" ? "" : formInline.hint_info, // 店家提示
                    spec_list_json: newid == "" ? "" : JSON.stringify(newid), // 规格属性列表（name:规格名称 list:属性数组）
                    spec_info_json: this.data2 == "" ? "" : JSON.stringify(this.data2) // 规格属性信息（sku_img:属性图片 price:单价 stock:库存数量 spec_value:属性数组）
                };

                let isTrue = true;

                if (this.data2) {
                    this.data2.forEach(e => {
                        if (e.price == 0) {
                            isTrue = false;
                        }
                    });
                    if (!isTrue) {
                        message.warning("请填写规格中的单价和库存");
                    }
                }

                if (newid == "") {
                    message.warning("请添加规格");
                    isTrue = false;
                } else if (this.data2 == "") {
                    message.warning("规格属性不能为空");
                    isTrue = false;
                }

                if (isTrue) {
                    // 上传商品（调接口）
                    this.uploadproduct(a, id);
                }
            } else {
                this.$message.error("请检查是否全部填写");
            }
        });
    }

    // 关闭编辑修改弹框
    handleCloseEditModal(name) {
        this.$refs[name].resetFields();
        let a = {
            id: "",
            goodsImg: "",
            goodsTitle: "",
            type: "",
            freeShippingValue: "",
            price: "",
            unit: "",
            specifications: "",
            goods_desc: "",
            goodsImg_desc: "",
            hint_info: "",
            province: "",
            city: "",
            goodsQualityImg: "",
            putonStatus: ""
        };

        let b = this.state.formInline;

        this.setState({
            goods_file_list: [],
            goods_file_list_desc: [],
            goods_quality_list: [],
            current_pc: "",
            current_province: "",
            current_city: "",
            province_value: "",
            city_value: "",
            ruleNum: 0,
            formInline: { ...b, ...a },
            edit_modal: false,
            data3: [],
        })
        // 刷新页面
        this.handleFilterChange();
    }

    // 发布新商品需要选择橱窗
    // async handleShoWwin() {
    //     this.setState({
    //         winStatus: true,
    //     })
    //     let { data, flag, msg } = await this.getWin();
    //     if (flag === 1) {
    //         this.setState({
    //             win_list: data,
    //         })
    //     } else {
    //         message.error(msg);
    //     }
    // }

    // 打开新增商品弹框
    handleShowAddModal() {
        this.setState({
            edit_modal: true,
            spec_data: [],
            data2: [],
        })
    }

    // 商家筛选
    async changeMechant(e) {
        this.setState({
            merchant_iname: e,
        })
        await this.getDataList();
    }

    // 审核筛选
    async changeAuditStatus(e) {
        this.setState({
            audit_iname: e == undefined ? "-1" : e,
        })
        await this.getDataList();
    }

    // 获取商家列表
    // async getMechantData2() {
    //     let params = {
    //         merchant_type: this.state.type
    //     };
    //     const { msg, flag, data } = await getMechantData(params);
    //     if (flag == 1) {
    //         this.setState({
    //             MerchantData: data,
    //         })
    //     } else {
    //         message.error(msg);
    //     }

    //     let req = '';
    //     app.post(api.getCity, { type: 2, province_name: e }).then(data => {
    //         req = data;
    //     })
    //     if (req.flag === 1) {
    //         const list = req.data || [];
    //         this.setState({
    //             city_list: list,
    //         })
    //     }
    // }

    /**
     * 关闭详情弹框
     */
    handleClose() {
        this.setState({
            detail_modal: false,
            sel_detail: {},
            merchant_logo: [],
            business_license: [],
            product_img: [],
            manufacturer_img: [],
            isData: false,
        })
    }

    // 打开自定义规格单价详情弹框
    open2(e, i) {
        console.log("进来了");
        let a = [];
        let b = [];
        let obj = {
            show_url: this.state.imgUrl + e.sku_img,
            url: e.sku_img
        };
        a.push(obj);

        if (e.sku_img == "") {
            b = [];
        } else {
            b = a;
        }

        this.setState({
            lindex: i,
            itemName: e.itemName,
            descValue: e.spec_value.join("/"),
            itemPrice: e.price,
            itemStock: e.stock,
            classImgList: b,
            editSpecDesc: true,
        })
    }

    // 关闭规格弹框
    async handleCloseSpec_modal() {
        message.info("关闭规格弹框");
        this.setState({
            current: 0,
            spec_modal: false,
            editSpecDesc: false,
            renameSpec: false,
            spec_edit_status: false,
            spec_input_title: "",
        })
    }

    // 添加自定义属性
    addDivAttr(e) {
        let a = this.state.spec_data;
        a.forEach(i => {
            if (e == i.title) {
                if (i.title == "") {
                    message.warning("属性名不能为空");
                } else {
                    i.flag = 1;
                    i.datai.push({
                        name: "",
                        // statu: false, // 是否删除属性 true 是 false 否
                        flag: 1 // 是否显示属性 true 是 false 否
                    });
                }
            }
        });
        this.setState({
            spec_data: a,
        })
    }

    // 弹出重命名弹窗
    rename(e, i) {
        this.setState({
            itemSpeName: e,
            lindex: i,
            renameSpec: true,
        })
    }

    // 勾选商品种类的变化
    handleChangeVariety(e) {
        this.setState({
            variety_list_index: e == undefined ? 0 : e,
        })
        this.getDataList();
    }

    // 勾选商品状态的变化
    handleChangeStatus(e) {
        this.setState({
            goodsStatus: e == undefined ? 10 : e,
        })
        this.getDataList();
    }

    // 是否展开（闭合）规格类型
    showUp(e, k) {
        let a = this.state.spec_data;
        a.forEach(i => {
            if (i.title == k) {
                if (i.flag == 1) {
                    i.flag = 0;
                } else {
                    i.flag = 1;
                }
            }
        });
        this.setState({
            spec_data: a,
        })
    }

    // 移除一项分类数据
    delData(e, k, x) {
        // item.title, index2, index
        const { delStatus, isReg } = this.state;
        let a = this.state.spec_data;
        let b = this.state.data3;
        let c = this.state.isReg;
        if (delStatus) {
            a.forEach((i, index, arr) => {
                if (e == i.title) {
                    // let b = arr[x].datai.length - 1;

                    // 处理已有规格下删除已有规格数据
                    // 父：title
                    let obj = {
                        spec_id: i.spec_id,
                        name: i.title,
                        list: []
                    };

                    // 子：list
                    let opq = {
                        value_id: i.datai[k].value_id,
                        name: i.datai[k].name,
                        flag: i.datai[k].flag,
                        is_delete: 1
                    };
                    // spec_name
                    obj.list.push(opq);
                    // 判断是否已存在该数组
                    if (b != "") {
                        let a = true;
                        b.forEach(i => {
                            // 存在
                            if (i.spec_id == obj.spec_id) {
                                i.list.push(opq);
                                a = false;
                            }
                        });

                        if (a) {
                            obj.is_delete = 1;
                            b.push(obj);
                        }
                        this.setState({
                            data3: b,
                        })
                    } else {
                        // 如果b等于0，则代表该数组已经被完全删除，则写入data3中，否则就在原数组把is_delete改为1
                        // if (b == 0) {

                        // } else {
                        //   this.data3.push(obj);
                        // }
                        b.push(obj);
                        this.setState({
                            data3: b,
                        })
                    }

                    // 处理完数据后再移除数据
                    i.datai.splice(k, 1);

                    // 判断属性数组是否为空，是则删除整个规格项
                    if (i.datai == "") {
                        if (i.value_id == "" || i.value_id == undefined) {
                            console.log("判断属性数组是否为空，是则删除整个规格项");
                            if (c) {
                                b.forEach(i => {
                                    i.is_delete = 1;
                                });
                                this.setState({
                                    data3: b,
                                })
                            }
                            this.setState({
                                isReg: false,
                            })
                            // 初始化时没有该规格名称A，新增规格名称A，执行删除操作，不存入删除数组中
                        } else {
                            // 处理属性值为空的list的规格数组
                            c = true;
                            b.push(i);
                            b.forEach(i => {
                                i.is_delete = 1;
                            });
                            this.setState({
                                isReg: true,
                                data3: b,
                            })
                        }
                        a.splice(x, 1);
                        this.setState({
                            spec_data: a,
                        })
                    }
                }
            });
            this.setState({
                spec_data: true,
                delStatus: false,
            })
            setTimeout(() => {
                this.setState({
                    delStatus: true,
                })
            }, 200);
        } else {
            message.warning("一个一个删除，不要急");
        }

        // console.log(this.spec_data);
        // console.log(this.data3);
        // console.log('==================================');
    }

    // // 上架/下架商品
    // putOnGoods(a, b) {
    //     console.log({ a, b });
    //     if (b.product_id) {
    //         // 弹框确认执行
    //         let content = a == 0 ? "确认下架该商品吗？" : "确认上架该商品吗？";

    //         this.$Modal.confirm({
    //             okText: "确认",
    //             content,
    //             onOk: async () => {
    //                 // this.edit_modal = false;
    //                 await this.handleGoodsOn({
    //                     place_status: a == 0 ? 2 : 1,
    //                     product_id: b.product_id
    //                 });
    //             }
    //         });
    //     } else {
    //         message.warning("商品参数有误，正在刷新，请稍后重试");
    //         window.location.reload();
    //     }
    // }

    // 上下架商品（调接口）
    // async handleGoodsOn(a) {
    //     let res = await setGoodsOn(a);

    //     if (res) {
    //         let b = a.place_status == 1 ? "上架成功" : "下架成功";
    //         message.success(b);
    //         this.detail_modal = false;
    //         await this.getDataList();
    //     } else {
    //         let b = a.place_status == 1 ? "上架失败" : "下架失败";
    //         message.error(b);
    //     }
    // }

    onChangeAttr(ele) {
        // console.log(ele.target.value);
        const { spec_data, voidsName, lindex } = this.state;
        let a = spec_data;
        a.forEach(e => {
            if (e.title == voidsName) {
                e.datai.forEach((j, k) => {
                    if (k == lindex) {
                        j.name = ele.target.value;
                    }
                });
            }
        });
        this.setState({
            spec_data: a
        })
    }

    // 验证是否数字+小数点
    checkNumber2(e) {
        let a = /^[0-9.]*$/;
        return a.test(e);
    }

    // 验证是否纯数字
    checkNumber(e) {
        let a = /^[0-9]*$/;
        return a.test(e);
    }

    // 保存修改的图片、单价、库存
    save_price_stock() {
        if (!this.checkNumber2(this.itemPrice)) {
            return message.warning("请输入正确的单价");
        }
        // 库存只能是整数，不能为小数
        if (!this.checkNumber(this.itemStock)) {
            return message.warning("请输入整数形式的库存");
        }
        this.editSpecDesc = false;
    }

    // 打开规格弹框
    async select_spec() {
        this.setState({
            spec_modal: true,
        })

        // 获取规格详情
        if (this.state.formInline.id != "") {
            app.post(api.getLogistics, {
                product_id: this.state.formInline.id,
                merchant_id: this.state.winInfo.merchant_id,
            }).then(data => {

            })
        }
    }

    // 获取单价框值
    onChangePrice(ele) {
        let osTrue = false;
        if (ele.target.value === 0) {
            osTrue = true;
        }

        if (ele.target.value === "") {
            osTrue = true;
        }

        if (osTrue) {
            message.warning("单价不能为空");
        } else {
            this.itemPrice = ele.target.value;
            let a = ele.target.value.toString();
            let b = a.indexOf(".");
            let c = a.slice(b + 1);

            // 判断输入值是否正确
            if (!this.checkNumber2(this.itemPrice)) {
                return message.warning("请输入正确的单价");
            }

            // 判断小数位
            if (b !== -1) {
                if (c.length > 2) {
                    return message.warning("最多输入两位小数");
                }
            }

            this.data2.forEach((e, i) => {
                if (i == this.lindex) {
                    if (c.length > 2) {
                        if (b !== -1) {
                            let d = a.substring(0, b + 3);
                            e.price = d;
                        } else {
                            e.price = a;
                        }
                    } else {
                        e.price = ele.target.value;
                    }
                }
            });
        }
    }

    // 获取库存框值
    onChangeStock(ele) {
        this.itemStock = ele.target.value;
        this.data2.forEach((e, i) => {
            if (i == this.lindex) {
                e.stock = ele.target.value;
            }
        });
    }

    /**
     * 打开详情弹框
     */
    async handleShowDetail(sel_id) {
        this.setState({
            sel_id: sel_id,
            detail_modal: true,
        })
        app.post(api.getLogistics, { product_id: sel_id }).then(({ data, flag }) => {
            if (flag == 1) {
                if (this.state.sel_detail.merchant_type == "2") {
                    this.setState({
                        business_license: this.state.sel_detail.business_license
                    })
                }
                this.setState({
                    sel_detail: data || {},
                    isData: true,
                    merchant_logo: this.state.sel_detail.merchant_logo,
                    business_license: this.state.sel_detail.business_license,
                    product_img: this.state.sel_detail.product_img,
                    manufacturer_img: this.state.sel_detail.manufacturer_img,
                })
            }
        })
    }

    // 打开编辑商品弹框
    // async handleShowEditModal(e) {
    //     app.post(api.MallDetails, { product_id: e.product_id }).then(({ data, flag,msg }) => {
    //         if (flag === 1) {
    //             this.edit_modal = true;
    //             let aaa = "";
    //             if (data.status == 1) {
    //                 aaa = "1";
    //             } else if (data.status == 0) {
    //                 aaa = "2";
    //             }

    //             // 保存商家id
    //             this.winInfo = { merchant_id: data.merchant_id };

    //             this.formInline = {
    //                 id: data.product_id,
    //                 goodsImg: data.product_img || "",
    //                 goodsTitle: data.product_name || "",
    //                 type: data.variety_id,
    //                 freeShippingValue: data.mail_way || "",
    //                 first_weight_number:
    //                     data.first_weight_number == "" || data.first_weight_number == null
    //                         ? 0
    //                         : Number(data.first_weight_number),
    //                 price: data.product_price || "",
    //                 unit: data.product_unit || "",
    //                 specifications: "",
    //                 shipment: "",
    //                 province: data.ship_province || "",
    //                 city: data.ship_city || "",
    //                 goods_desc: data.product_manual || "",
    //                 goodsImg_desc: data.manufacturer_img || [],
    //                 hint_info: data.hint_info || "",
    //                 putonStatus: aaa
    //             };

    //             this.logiData = data.mail_list || [];

    //             this.current_province = data.ship_province || ""; // 当前选择的省
    //             this.current_city = data.ship_city || ""; // 当前选择的市
    //             this.province_value = data.ship_province || "";
    //             this.city_value = data.ship_city || "";

    //             let a1 = data.product_img; // 商品图片
    //             let a2 = data.manufacturer_img; // 描述图片

    //             let goods_file_list2 = [];
    //             let goods_file_list_desc2 = [];
    //             let spec_data2 = data.spec_list || [];
    //             let data3 = data.spec_info || [];

    //             // 处理图片数组
    //             if (a1 != "" && a1 != undefined) {
    //                 a1.forEach(j => {
    //                     let b = {
    //                         show_url: config.baseUrl + j,
    //                         url: j
    //                     };
    //                     goods_file_list2.push(b);
    //                 });
    //             }

    //             if (a2 != "" && a2 != undefined) {
    //                 a2.forEach(j => {
    //                     let b = {
    //                         show_url: config.baseUrl + j,
    //                         url: j
    //                     };
    //                     goods_file_list_desc2.push(b);
    //                 });
    //             }

    //             // 处理规格
    //             // console.log(data.spec_info);
    //             let newid = [];
    //             spec_data2.forEach(e => {
    //                 let obj = {
    //                     title: e.name,
    //                     flag: 1,
    //                     spec_id: e.spec_id,
    //                     is_delete: 0,
    //                     datai: []
    //                 };

    //                 if (e.list) {
    //                     let newid2 = [];
    //                     e.list.forEach(j => {
    //                         let obj2 = {
    //                             name: j.name,
    //                             flag: j.flag,
    //                             value_id: j.value_id
    //                         };
    //                         newid2.push(obj2);
    //                     });
    //                     obj.datai = newid2;
    //                 }

    //                 newid.push(obj);
    //             });

    //             // 处理规格详情
    //             let newiddetail = [];
    //             data3.forEach(e => {
    //                 let obj = {
    //                     price: e.price,
    //                     sku_img: e.sku_img,
    //                     sku_id: e.sku_id,
    //                     stock: e.stock,
    //                     spec_value: []
    //                 };

    //                 if (e.spec_value) {
    //                     let newiddetail2 = [];
    //                     e.spec_value.forEach(j => {
    //                         newiddetail2.push(j);
    //                     });
    //                     obj.spec_value = newiddetail2;
    //                 }

    //                 newiddetail.push(obj);
    //             });

    //             this.spec_data = newid; // 规格
    //             this.data2 = newiddetail; // 规格详情

    //             this.goods_file_list = goods_file_list2;
    //             this.goods_file_list_desc = goods_file_list_desc2;

    //         } else {
    //             message.warning(msg);
    //         }
    //     })
    // }

    // 打开新增规格弹窗
    openAddLogister() {
        message.success("打开规格弹框");
        console.log("打开规格弹框");
        this.setState({ spec_edit_status: true })
    }

    // 验证规则数
    checkRule(e) {
        if (e == "0") {
            let a = this.ruleNum;
            if (a - 1 == 0) {
                a = 0;
            } else if (a - 1 < 0) {
                a = 0;
            } else {
                a--;
            }
            this.ruleNum = a;
        } else {
            let a = this.ruleNum;
            if (a + 1 > this.ruleTotalNum) {
                a = this.ruleTotalNum;
            } else {
                a++;
            }
            this.ruleNum = a;
        }
    }

    // 切换类型
    async handleType(ty) {
        this.page = 1;
        this.type = ty;
        this.$refs.selectbox.clearSingleSelect();
        await this.getDataList();
        // await this.getMechantData2();
    }

    /**
     * 打开理由弹框
     */
    handleShowReason(sel_id) {
        this.reason_modal = true;
        this.sel_id = sel_id;
    }

    /**
     * 关闭理由弹框
     */
    handleCloseReason() {
        this.reason_modal = false;
        this.reason = "";
        this.sel_id = "";
    }

    handleConfirm(id, types) {
        let content =
            types == 1 ? "强制下架后用户无法操作商品上下架！" : "取消强制下架";
        this.$Modal.confirm({
            title: "确认操作",
            content: content,
            onOk: () => {
                this.handleEnforce(id, types);
            }
        });
    }

    /**
     * 审核
     */
    // async handleEnforce(id, types) {
    //     let parms = {
    //         product_id: id,
    //         enforce_status: types
    //     };
    //     const is_ok = await getProductEnforce(parms);
    //     if (is_ok) {
    //         message.success("操作成功");
    //         if (this.detail_modal) {
    //             // 如果详情弹框打开，就关闭
    //             this.handleClose();
    //         }
    //         const { dataList, page } = this;
    //         if (dataList.length === 1 && page > 1) {
    //             this.page = page - 1;
    //         }
    //         await this.getDataList();
    //         //this.getAuditCount();
    //     }
    // }

    // 获取快递、单位
    // async getGoodsTypeUnit2() {
    //     let params = {
    //         merchant_id: 1
    //     };
    //     const { flag, data, msg } = await getGoodsTypeUnit(params);

    //     if (flag === 1) {
    //         this.variety_list = data.variety_list || [];
    //         this.unit_list = data.product_unit || [];
    //     } else {
    //         message.error(msg);
    //     }
    // }

    // 获取橱窗
    // async getWin() {
    //     let params = {
    //         merchant_id: 1,
    //         buy_type: this.type
    //     };
    //     const { flag, data, msg } = await getMyWin(params);

    //     if (flag === 1) {
    //         this.win_list = data || [];
    //     } else {
    //         message.error(msg);
    //     }
    // }

    /**
     * 筛选变更
     */
    async handleFilterChange() {
        this.page = 1;
        await this.getDataList();
    }

    /**
     * 获取数据列表
     */
    async getDataList() {
        this.t_loading = true;
        this.setState({
            t_loading: true,
        })
        const { page, type, product_name, merchant_iname, audit_iname } = this;
        let parms = {
            page,
            request_type: type,
            merchant_id: merchant_iname || "-1",
            audit_status: audit_iname || "1"
        };
        if (product_name) {
            parms.product_name = product_name;
        }
        let req = '';
        app.post(api.AdminMallListing, parms).then(data => {
            req = data;
        })
        this.setState({
            t_loading: false,
        })
        if (req.flag == 1) {
            const data = req.data || [];
            let a = this.state.total;
            let b = this.state.dataList;
            a = Number(req.total) || 0;
            b = data.map((d_item, d_index) => {
                d_item.sort = (page - 1) * 20 + d_index + 1;
                return d_item;
            });
            this.setState({
                total: a,
                dataList: b,
            })
        }
    }

    /**
     * 页码改变
     */
    async changePage(page) {
        this.page = page;
        await this.getDataList();
    }

    /**
     * 查看大图
     */
    async handleBigImg(img) {
        this.review_url = img;
        this.$viewer.show();
        //window.open(img);
    }

    formRef = React.createRef();

    render() {
        const { info, callBackFun } = this.props;
        const { getFieldDecorator, getFieldValue } = this.props.form,
            { previewVisible, previewVisible2, editSpecDesc, previewImage, previewImage2, spec_edit_status, fileList, fileList2, classList, isEdit, current, spec_data, data2, imgUrl, spec_input_title, isExistSpec, itemSpeName, descValue, itemPrice, itemStock, spec_modal } = this.state,
            uploadButton = (
                <div>
                    <Icon type="plus" />
                    <div className="ant-upload-text">上传照片</div>
                </div>
            )
        const handleCanleAddEdit = () => {
            callBackFun(false);
        }
        return (
            <div className="mall-manage-add-good" style={{ overflowX: 'hidden' }}>
                <div className="page-title" style={{ display: 'inline-block' }}>{!isEdit ? '商品添加' : '商品编辑'}
                    <div onClick={() => handleCanleAddEdit()} style={{ display: 'inline-block', paddingLeft: '8px', color: '#1890ff', fontSize: '14px', cursor: 'pointer' }}>返回</div>
                </div>
                <div className="page-content">
                    <Form
                        onSubmit={this.handleSubmit}
                        style={{ paddingBottom: 20 }}
                        ref={this.formRef}
                    >

                        <FormItem
                            {...formItemLayout(4)}
                            label="商品分类"
                        >
                            {getFieldDecorator('class_id', {
                                rules: [{
                                    required: true, message: '请选择商品分类'
                                }],
                            })(
                                <Cascader notFoundContent="暂无商品分类"
                                    options={classList}
                                    placeholder="请选择商品分类"
                                    expandTrigger='hover'
                                    changeOnSelect={true}
                                />
                            )}
                        </FormItem>

                        <FormItem
                            label="商品图片(首张为封面图)"
                            {...formItemLayout()}
                        >
                            {getFieldDecorator('images', {
                                rules: [{ required: true, message: '请上传商品图片!' }],
                            })(
                                <Upload
                                    multiple={true}
                                    action={config.serverUrl + api.ImageUpload}
                                    data={{
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        token: app.getData('token'),
                                        upload_type: 'mall',
                                    }}
                                    name="image"
                                    fileList={fileList}
                                    listType="picture-card"
                                    accept="image/gif, image/jpeg, image/jpg, image/png"
                                    onPreview={this.handlePreview}
                                    onChange={this.handleChange}
                                    beforeUpload={this.handleBeforeUpload}
                                >
                                    {fileList.length > 0 ? null : uploadButton}
                                </Upload>
                            )}
                            <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                            </Modal>
                        </FormItem>

                        <FormItem
                            {...formItemLayout()}
                            label="商品名称"
                        >
                            {getFieldDecorator('name', {
                                rules: [{
                                    required: true, message: '请填写商品名称'
                                }],
                            })(
                                <Input placeholder="请填写商品名称" />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout()}
                            label="商品描述(文字)"
                        >
                            {getFieldDecorator('remark', {
                                rules: [{
                                    required: true, message: '请输入商品描述'
                                }],
                            })(
                                <Input.TextArea placeholder="请输入商品描述" autosize={{ minRows: 6, maxRows: 10 }} />
                            )}
                        </FormItem>

                        <FormItem
                            label="商品描述(图片)"
                            {...formItemLayout()}
                        >
                            {getFieldDecorator('manufacturer_img', {
                                rules: [{ required: true, message: '请上传商品描述图片!' }],
                            })(
                                <Upload
                                    multiple={true}
                                    action={config.serverUrl + api.ImageUpload}
                                    data={{
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        token: app.getData('token'),
                                        upload_type: 'mall',
                                    }}
                                    name="image"
                                    fileList={fileList2}
                                    listType="picture-card"
                                    accept="image/gif, image/jpeg, image/jpg, image/png"
                                    onPreview={this.handlePreview2}
                                    onChange={this.handleChange2}
                                    beforeUpload={this.handleBeforeUpload2}
                                >
                                    {fileList2.length > 0 ? null : uploadButton}
                                </Upload>
                            )}
                            <Modal visible={previewVisible2} footer={null} onCancel={this.handleCancel2}>
                                <img alt="example" style={{ width: '100%' }} src={previewImage2} />
                            </Modal>
                        </FormItem>

                        <FormItem
                            {...formItemLayout()}
                            label="店家提示"
                        >
                            {getFieldDecorator('statement', {
                                rules: [{
                                    required: false, message: '请填写店家提示'
                                }],
                            })(
                                <Input.TextArea placeholder="请输入店家提示" autosize={{ minRows: 6, maxRows: 10 }} />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout(4)}
                            label="商品售价(元)"
                        >
                            {getFieldDecorator('price', {
                                rules: [{
                                    required: true, message: '请填写商品售价'
                                }],
                            })(
                                <InputNumber precision={2} style={{ width: '100%' }} placeholder="请填写商品售价" />, <span style={{ color: 'red' }}> 此价格在商品列表显示，一般为商品最低价 </span>
                            )}
                        </FormItem>

                        <div>
                            <div
                                style={{
                                    position: 'relative',
                                    top: '30px',
                                    color: 'red',
                                    left: 'calc(24% - 70px)'
                                }}
                            >*</div>
                            <FormItem
                                {...formItemLayout(4)}
                                label="商品规格"
                            >
                                {getFieldDecorator('spec', {
                                    rules: [{
                                        required: false, message: '请新增规格'
                                    }],
                                })(
                                    <Button onClick={() => this.openSpecBox()} style={{ width: '100%' }}>+ 新增规格</Button>
                                )}
                            </FormItem>
                        </div>

                        <FormItem
                            {...formItemLayout(4)}
                            label="商品重量(kg)"
                        >
                            {getFieldDecorator('weight', {
                                rules: [{
                                    required: true, message: '请输入商品重量'
                                }],
                            })(
                                <InputNumber style={{ width: '100%' }} placeholder="请输入商品重量" />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout(4)}
                            label="生产数量"
                        >
                            {getFieldDecorator('produce_number', {
                                rules: [{
                                    required: true, message: '请填写生产数量'
                                }],
                            })(
                                <InputNumber style={{ width: '100%' }} placeholder="请填写生产数量" />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout(8)}
                            label="是否审核"
                        >
                            {getFieldDecorator('is_audit', {
                                rules: [{
                                    required: true, message: '请选择是否审核'
                                }]
                            })(
                                <RadioGroup placeholder="请选择是否审核">
                                    <Radio value="1">是</Radio>
                                    <Radio value="0">否</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout(8)}
                            label="是否限购"
                        >
                            {getFieldDecorator('is_astrict', {
                                rules: [{
                                    required: true, message: '请选择是否限购'
                                }]
                            })(
                                <RadioGroup placeholder="请选择是否限购">
                                    <Radio value="1">是</Radio>
                                    <Radio value="0">否</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>

                        {
                            getFieldValue('is_astrict') === '1' ? (
                                <div>
                                    <FormItem
                                        {...formItemLayout(4)}
                                        label="限购次数"
                                    >
                                        {getFieldDecorator('astrict_how', {
                                            rules: [
                                                { required: true, message: '请输入限购次数' },
                                                { type: 'integer', min: 1, message: '最少一件' },
                                            ]
                                        })(
                                            <InputNumber style={{ width: '100%' }} placeholder="请填写限购次数" />
                                        )}
                                    </FormItem>
                                    <FormItem
                                        {...formItemLayout(4)}
                                        label="限购数量"
                                    >
                                        {getFieldDecorator('astrict_number', {
                                            rules: [
                                                { required: true, message: '请输入限购数量' },
                                                { type: 'integer', min: 1, message: '最少一件' },
                                            ]
                                        })(
                                            <InputNumber style={{ width: '100%' }} placeholder="请填写限购数量" />
                                        )}
                                    </FormItem>
                                </div>
                            ) : null
                        }

                        <FormItem
                            {...formItemLayout(8)}
                            label="是否发货队部"
                        >
                            {getFieldDecorator('is_team', {
                                rules: [{
                                    required: true, message: '请选择是否发货队部'
                                }]
                            })(
                                <RadioGroup placeholder="请选择是否发货队部">
                                    <Radio value="1">是</Radio>
                                    <Radio value="0">否</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout(8)}
                            label="商品状态"
                        >
                            {getFieldDecorator('status', {
                                rules: [{
                                    required: true, message: '请选择商品状态'
                                }]
                            })(
                                <RadioGroup placeholder="请选择商品状态">
                                    <Radio value="true">上架</Radio>
                                    <Radio value="false">下架</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>

                        <div style={{ textAlign: 'center' }}>
                            <Button type="primary" onClick={this.handleSubmit}> {info.id == '' ? '添加' : '保存'} </Button>
                        </div>
                    </Form>
                </div>

                <Drawer
                    visible={spec_modal}
                    maskClosable={true}
                    width="544"
                    placement="right"
                    // scrollable={true}
                    title={spec_data != '' ? '修改规格' : '新增规格'}
                    onClose={() => this.handleCloseSpec_modal()}
                    className="spec_box"
                // style={{ backgroundColor: 'lightpink' }}
                >

                    <div>
                        <p>当前正在进行第 {current + 1} 步</p>
                        <Steps className="spec_step" current={current}>
                            <Steps.Step title="设置规格名以及规格属性"></Steps.Step>
                            <Steps.Step title="设置单价和库存"></Steps.Step>
                        </Steps>

                        <div className="spec_main" style={{ display: (current == 0) ? '' : 'none' }}>
                            <span style={{ display: (spec_data == '') ? '' : 'none' }}>暂无数据，点击右下角新增规格</span>
                            {
                                spec_data.map((item, index) => {
                                    return (
                                        <div className="spec" key={index}>
                                            <div className="spec_title">
                                                <div className="title">{item.title}</div>

                                                <div className="remaneBox">
                                                    <a
                                                        className="rename"
                                                        onClick={() => this.rename(item.title, index)}
                                                    >重命名</a>

                                                    <div onClick={() => this.showUp(item.flag, item.title)}>
                                                        <Icon
                                                            type="ios-arrow-up"
                                                            className="iconup"
                                                            style={{ display: (item.flag == 1) ? '' : 'none' }}
                                                        />
                                                        <Icon
                                                            style={{ display: (item.flag == 0) ? '' : 'none' }}
                                                            type="ios-arrow-down"
                                                            className="iconup"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                item.datai.map((item2, index2) => {
                                                    return (
                                                        <div
                                                            className="spec_name"
                                                            key={index2}
                                                        >
                                                            <div>
                                                                <Input
                                                                    style={{ marginBottom: '16px', display: (item.flag == 1) ? '' : 'none' }}
                                                                    className="inp"
                                                                    value={item2.name}
                                                                    placeholder="请输入属性名称"
                                                                    ref="ainput"
                                                                    onClick={() => this.getIndex(index2, item.title)}
                                                                    onChange={(e) => this.onChangeAttr(e)}
                                                                    prefix={
                                                                        <div className="prefix">
                                                                            <Icon
                                                                                style={{ color: 'red' }}
                                                                                type="delete"
                                                                                onClick={() => this.delData(item.title, index2, index)}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    suffix={
                                                                        <div onClick={() => this.handleShowAttr(index2, item)}>
                                                                            <div className={item2.flag == 1 ? 'suffix' : 'suffix active'}>
                                                                                <span className={item2.flag == 1 ? 'icon_circle' : 'icon_circle active2'}></span>
                                                                                <span className={!item2.flag == 1 ? 'icon_text ' : 'icon_text active3'}>
                                                                                    {item2.flag == 1 ? "显示" : "隐藏"}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                >
                                                                </Input>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }

                                            <a className="plusAttr" style={{ display: item.flag == 1 ? '' : 'none' }} onClick={() => this.addDivAttr(item.title)}> +添加自定义属性</a>
                                        </div >
                                    )
                                })
                            }
                        </div >

                        <div className="spec_desc" style={{ display: (current == 1) ? '' : 'none' }}>
                            {
                                data2.map((item, index) => {
                                    return (
                                        <div
                                            className="item"
                                            style={{ cursor: 'pointer' }}
                                            key={index}
                                            onClick={() => this.open2(item, index)}
                                        >
                                            <div className="imgBox">
                                                <img
                                                    style={{ display: (item.sku_img != '') ? '' : 'none' }}
                                                    src={imgUrl + item.sku_img}
                                                    alt=""
                                                    className="img"
                                                />
                                                <Icon
                                                    style={{ cursor: 'pointer', display: (item.sku_img == '') ? '' : 'none' }}
                                                    type="md-add-circle"
                                                />
                                            </div>
                                            <div className="price">
                                                <div className="bottom">
                                                    <span className="text">
                                                        {item.spec_value.join(",")}
                                                    </span>
                                                    <Icon type="ios-create-outline" />
                                                </div>
                                                <div className="top">
                                                    <span className="price-p">单价：{item.price ? item.price : 0}</span>
                                                    <span className="stock-p">库存：{item.stock ? item.stock : 0}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div >

                        <div style={{ height: '16px', borderTop: '1px solid #f0f0f0' }}></div>

                        <div style={{ justifyContent: 'flex-end', display: (current == 0) ? 'flex' : 'none' }}>
                            <Button
                                style={{ marginRight: '16px', display: (current == 0) ? '' : 'none' }}
                                type="primary"
                                onClick={() => this.openAddLogister()}
                            >新增规格</Button>
                            <Button type="primary" onClick={() => this.next()}> 下一步</Button >
                        </div>

                        <div style={{ justifyContent: 'flex-end', display: (current == 1) ? 'flex' : 'none' }}>
                            <Button type="primary" onClick={() => this.prev()} style={{ marginRight: '16px' }}>上一步</Button>
                            <Button type="primary" onClick={() => this.save()}> 保存</Button>
                        </div >
                    </div>

                    {/* <Drawer
                            title="规格名"
                            closable={false}
                            placement="bottom"
                            maskClosable={false}
                            getContainer={false}
                            onClose={() => this.closeTheRenameDrawer()}
                            style={{ position: 'absolute' }}
                        >
                            <Input.Search
                                enterButton="确定"
                                value={itemSpeName}
                                placeholder="请输入规格名.."
                                onClick={() => this.save_spec_rename_title()}
                                onSearch={() => this.save_spec_rename_title()}
                            />
                        </Drawer> */}

                    <Drawer
                        title="设置图片、单价、库存"
                        maskClosable={false}
                        placement="bottom"
                        getContainer={false}
                        height="60"
                        onClose={() => this.closeTheEditDrawer()}
                        style={{ position: 'absolute' }}
                    >
                        <div className="price_stock_img_box">
                            <div className="img_box">eee</div>

                            <div className="title2">{descValue}</div>

                            <div className="price-stock-box">
                                <div className="price-stock-item" style={{ marginBottom: '16px' }}>
                                    <span className="mun">单价：</span>
                                    <Input value={itemPrice} placeholder="请输入该规格的单价" onChange={() => this.onChangePrice()} />
                                </div>

                                <div className="price-stock-item">
                                    <span className="mun">库存：</span>
                                    <Input value={itemStock} placeholder="请输入该规格的库存数量" onChange={() => this.onChangeStock()} />
                                </div>
                            </div>

                            <Button type="primary" className="save_price_stock" onClick={() => this.save_price_stock()}> 确定</Button>
                        </div>
                    </Drawer>

                </Drawer>

                <Drawer
                    width="348"
                    title="设置规格"
                    placement="right"
                    closable={true}
                    visible={editSpecDesc}
                    onClose={() => this.closeTheDrawer()}
                >
                    <Input
                        value={spec_input_title}
                        placeholder="请输入规格名称.."
                        onPressEnter={() => this.save_spec_title()}
                        onChange={(e) => this.save_spec_title2(e)}
                    />
                    <div style={{ color: 'red', display: isExistSpec ? '' : 'none' }}>该规格已存在,请更换名称</div>
                    <div style={{ display: 'flex', justifyContent: 'end', marginTop: '16px' }}>
                        <Button onClick={() => this.save_spec_title()} type="primary">
                            确认
                        </Button>
                    </div>
                </Drawer>
            </div>
        )
    }
}


export default Form.create()(MMAddGood)



// WEBPACK FOOTER //
// ./src/routes/mall_manage/MMGoodEditBox.jsx